var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisaSolid(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4h20a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V6a2 2 0 012-2zm4 6.63l1 3.69h1.28l1.98-4.63H9l-1.34 3.15-.51-2.68a.56.56 0 00-.55-.47h-2v.14a5.26 5.26 0 011.12.39.53.53 0 01.28.41zm3.72 3.69l1-4.63h1.2l-1 4.63h-1.2zm2.02-.18c.424.165.875.25 1.33.25h.02c1.26 0 2.08-.62 2.08-1.58.006-.733-.598-1.05-1.082-1.305-.32-.168-.588-.31-.588-.525 0-.17.16-.39.5-.39.39-.02.779.06 1.13.23l.21-1a3.24 3.24 0 00-1.11-.2c-1.16 0-2 .63-2 1.53 0 .66.58 1.04 1.05 1.26.04.02.079.037.115.054.38.175.505.233.505.516 0 .31-.37.45-.71.45a2.48 2.48 0 01-1.23-.29l-.22 1zm6.54.18l-.15-.69h-1.51l-.25.69h-1.26l1.8-4.32a.55.55 0 01.51-.34h1l1 4.63-1.14.03zM18 12.68h-1l.64-1.74.36 1.74z",
    fill: "#121318"
  })));
}

export default SvgVisaSolid;